import React, { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';

interface SSORegisterProps {
  onSuccess?: () => void;
  onError?: (error: string) => void;
}

export const SSORegister: React.FC<SSORegisterProps> = ({ onSuccess: _onSuccess, onError }) => {
  const { initiateSSORegister } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSSORegister = async () => {
    setIsLoading(true);
    setError(null);

    try {
      // This will redirect to the SSO app for registration
      await initiateSSORegister();
      // Note: The component will unmount due to redirect, so onSuccess won't be called here
    } catch (err) {
      const errorMsg = 'Failed to initiate SSO registration. Please try again.';
      setError(errorMsg);
      onError?.(errorMsg);
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center p-4">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
        <span className="ml-2 text-gray-600">Redirecting to SSO...</span>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {error && (
        <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded">
          {error}
        </div>
      )}
      
      <button
        onClick={handleSSORegister}
        disabled={isLoading}
        className="w-full flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z" clipRule="evenodd" />
        </svg>
        Register with SSO
      </button>
      
      <div className="text-center text-sm text-gray-500">
        <p>This will redirect you to your organization's SSO provider to create an account</p>
      </div>
    </div>
  );
}; 